import React from 'react';
import {useSelector} from 'react-redux';
import {Link} from 'react-router-dom';

import Sidebar from '../../components/Navigation/Sidebar';
import Topbar from '../../components/Navigation/Topbar';
import logo from '../../assets/img/logo.png';
import PropTypes from "prop-types";

export default function Layout({ children }) {
    const {isActiveSignature, isEnableFreeSignature} = useSelector((state) => state.UserReducer);
    const currentPath = window.location.pathname;
    const isPlansRoute = currentPath === '/plans' || currentPath === '/plans/payment';
    const paidSignatureInactive = isActiveSignature === false;
    const hasFreeTrialActive = isEnableFreeSignature === true;
    /** Assinatura paga inativa mas período gratuito válido → mesma UX de assinante (chrome + rotas normais). */
    const blockedByExpiredSubscription = paidSignatureInactive && !hasFreeTrialActive;
    const hideAppChrome = blockedByExpiredSubscription;
    const showExpiredScreen = blockedByExpiredSubscription && !isPlansRoute;

    return (
        <div style={{ overflowX: 'hidden', maxWidth: '100%', backgroundColor: '#0a0e27' }}>
            <div id="wrapper" style={{ maxWidth: '100%', overflowX: 'hidden', backgroundColor: '#0a0e27' }}>
                {!hideAppChrome && <Sidebar />}
                <div
                    id="content-wrapper"
                    className="d-flex flex-column flex-grow-1"
                    style={{
                        minHeight: '100vh',
                        flex: '1 1 0%',
                        minWidth: 0,
                        maxWidth: '100%',
                        overflowX: 'hidden',
                        backgroundColor: '#0a0e27',
                    }}
                >
                    <div
                        id="content"
                        className="d-flex flex-column flex-grow-1 w-100"
                        style={{ minWidth: 0, maxWidth: '100%' }}
                    >
                        {!hideAppChrome && <Topbar/>}
                        <div
                            className="container-fluid d-flex flex-column flex-grow-1"
                            style={{ minHeight: 0, minWidth: 0, maxWidth: '100%', width: '100%' }}
                        >
                            {showExpiredScreen ? (
                                <div
                                    style={{
                                        minHeight: '100vh',
                                        minHeight: '100dvh',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        padding: '56px 16px 24px',
                                        boxSizing: 'border-box',
                                    }}
                                >
                                    <img
                                        src={logo}
                                        alt="GBinary"
                                        style={{
                                            display: 'block',
                                            width: '132px',
                                            height: 'auto',
                                            margin: '0 auto 18px',
                                        }}
                                    />
                                    <div
                                        style={{
                                            width: '100%',
                                            maxWidth: '460px',
                                            background: 'linear-gradient(145deg, rgba(26, 32, 58, 0.98) 0%, rgba(18, 22, 42, 1) 100%)',
                                            border: '1px solid rgba(242, 146, 5, 0.28)',
                                            borderRadius: '16px',
                                            padding: '24px 20px',
                                            boxShadow: '0 12px 40px rgba(0, 0, 0, 0.42), 0 0 0 1px rgba(0, 0, 0, 0.18)',
                                            color: 'rgba(230, 235, 250, 0.95)',
                                            textAlign: 'center',
                                        }}
                                    >
                                        <h2
                                            style={{
                                                margin: '0 0 10px',
                                                color: '#f29205',
                                                fontSize: '1.1rem',
                                                fontWeight: 800,
                                            }}
                                        >
                                            Sua assinatura expirou!
                                        </h2>
                                        <p
                                            style={{
                                                margin: 0,
                                                fontSize: '14px',
                                                lineHeight: 1.6,
                                                color: 'rgba(205, 212, 232, 0.92)',
                                            }}
                                        >
                                            Assine e obtenha acesso a esse e todos os recursos da plataforma.
                                        </p>
                                        <Link
                                            to="/plans"
                                            style={{
                                                display: 'inline-flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                marginTop: '18px',
                                                minHeight: '44px',
                                                padding: '10px 22px',
                                                borderRadius: '10px',
                                                fontSize: '14px',
                                                fontWeight: 700,
                                                color: '#ffffff',
                                                textDecoration: 'none',
                                                background: 'linear-gradient(135deg, #f29205 0%, #ff6b35 100%)',
                                                boxShadow: '0 4px 15px rgba(242, 146, 5, 0.3)',
                                            }}
                                        >
                                            Clique aqui para ativar
                                        </Link>
                                    </div>
                                </div>
                            ) : (
                                children
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

Layout.propTypes = {
    children: PropTypes.element.isRequired,
};